import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FF7474" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/cravingsbrookswoodcoffeeNbakery/"
            >
              <CFImage
                w="55px"
                pr="10px"
                src={facebook}
                alt="Cravings Brookswood Restaurant Facebook"
              />
            </CFLink>
            {/*<CFLink href="https://www.yelp.ca/biz/sushi-musa-langley-city">
              <CFImage w="40px" pr="10px" src={yelp} alt="Cravings Brookswood Restaurant Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/88-palpal-noodle-house-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Cravings Brookswood Restaurant Zomato"
              />
            </CFLink>*/}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/cravingsbrookswood/"
            >
              <CFImage
                w="55px"
                pr="10px"
                src={instagram}
                alt="Cravings Brookswood Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FF7474" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/cravingsbrookswoodcoffeeNbakery/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Cravings Brookswood Restaurant Facebook"
                hover
              />
            </CFLink>
            {/*<CFLink href="https://www.yelp.ca/biz/sushi-musa-langley-city">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Cravings Brookswood Restaurant Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/88-palpal-noodle-house-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Cravings Brookswood Restaurant Zomato"
                hover
              />
            </CFLink>*/}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/cravingsbrookswood/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Cravings Brookswood Restaurant Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
